import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Sidenav from "Common/Components/examples/Sidenav";
import theme from "Common/hooks/assets/theme";
import AdminRoutes from "PlatForms/OrgLMS/Routes/AdminRoutes/AdminRoutes";
import { useSoftUIController } from "Common/hooks/context";
import brand from "Common/hooks/assets/images/lmsLogo1.png";
import Login from "Common/Auth/SignIn";
import DashboardLayout from "Common/Components/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "Common/Components/examples/Navbars/DashboardNavbar";
import CourseList from "../TrainingLibrary/CourseList";
import CourseDetail from "../TrainingLibrary/CourseDetail";
import MentorGroupDetail from "../Internship/MentorGroupsList";
import TrainingsList from "../Trainings/trainingList";
import TrainingDetail from "../Trainings/trainingDetail";
import { showSidebar } from "Common/Client/routeUtils";
import { getRoutes } from "Common/Client/routeUtils";
import { TrainingSection } from "../LandingPage/trainingSectionList";
import { PendingRequests } from "../LandingPage/PendingRequestLists";
import Register from "Common/Auth/SignUp";
import PendingBusinessGroups from "../BussinessGroup.js/PendingBussinessGroup";
import BusinessGroupsList from "../BussinessGroup.js/BusinessGroupList";
import LearnersList from "../UsersLists/LearnersList";
import MentorsList from "../UsersLists/MentorList";
import ManagersList from "../UsersLists/ManagerList";
import { DarkMode } from "@mui/icons-material";
import BusinessGroupDetail from "../BussinessGroup.js/BusinessGroupDetail";

function AdminContent() {
  const [controller] = useSoftUIController();
  const { layout, sidenavColor } = controller;
  const location = useLocation();

  useEffect(() => {
    sessionStorage.setItem("currentPath", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {layout === "dashboard" && showSidebar && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={brand}
              brandName="Admin"
              routes={AdminRoutes}
            />
          </>
        )}
        <DashboardLayout>
          <DashboardNavbar />
          <Routes>
            {getRoutes(AdminRoutes)}
            <Route path="*" element={<Navigate to="/admin-dashboard" />} />
            <Route path="/login" name="Login" element={<Login />} />
            <Route path="/register" name="Register" element={<Register />} />
            {/* <Route path="/library-fields-area" name="library-fields-area" element={<LibraryFieldArea />} /> */}
            <Route path="/business-group" element={<CourseList />} />
            <Route path="/course-detail/:id" element={<CourseDetail />} />
            <Route path="/groups-list" element={<MentorGroupDetail />} />
            <Route path="/business-group-detail" element={<BusinessGroupDetail/>} />
            <Route path="/training-list" element={<TrainingsList />} />
            <Route path="/training-detail/:id" element={<TrainingDetail />} />
            <Route path="/training-section-list" element={<TrainingSection />} />
            <Route path="/pending-request-list" element={<PendingRequests darkMode={false} />} />
            <Route path="/business-groups/pending" element={<PendingBusinessGroups />} />
            <Route path="/business-groups/list" element={<BusinessGroupsList />} />
            <Route path="/total-learners" element={<LearnersList />} />
            <Route path="/mentor" element={<MentorsList />} />
            <Route path="/managers" element={<ManagersList />} />
          </Routes>
        </DashboardLayout>
      </ThemeProvider>
    </>
  );
}
export default AdminContent;
